"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelContext = void 0;
var react_1 = require("react");
exports.ChannelContext = (0, react_1.createContext)({
    associatedMasterDealerIds: [],
    accounts: [],
    masterDealers: [],
    needsAccountSelection: false,
    selectedChannel: null,
    selectedMasterDealerId: null,
    hasCoop: false,
    groups: [],
    coop: {
        hasCoop: false,
        masterDealerBalance: null,
        availableBalance: null,
        isCoopUpdating: null,
        allowanceUsed: false,
        allowance: null,
    },
    setState: function () { return undefined; },
    updateBalance: function () { return undefined; },
    refreshUserData: function () { return undefined; },
});
